<template>
  <div class="new_page_index">
    <!-- 用 img 标签渲染原图，天然宽度自适应、不裁切 -->
    <div class="bg_wrap">
      <img
        class="bg_img"
        :src="homeBgUrl"
        alt="首页背景"
        mode="widthFix"
      />
      <!-- 叠加在图片上的文字层 -->
      <div class="text_layer">
        <div class="text_main">成人智能输液椅服务</div>
        <div class="text_tags">
          <span>手机充电</span>
          <span>影视娱乐</span>
          <span>座椅功能</span>
          <span>全套功能</span>
        </div>
        <button class="start_btn" @click="handleClick">立即开始</button>
        <div class="text_tip">孕妇、心脑血管疾病患者或体内安装医用器械者禁止按摩</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewPageIndex',
  data() {
    return {
      // require 由 webpack file-loader 处理，返回带 hash 的绝对 URL，兼容中文路径
      homeBgUrl: require('@/assets/new_adult_img/首页背景.png')
    }
  },
  methods: {
    handleClick() {
                      this.$router.push({
                      path: "/new-page-money-list"
                    });
    }
  }

}
</script>

<style scoped>
.new_page_index {
  width: 100vw;
  /* 容器高度由图片撑开，不写死 min-height */
  overflow-x: hidden;
  box-sizing: border-box;
  
}
.bg_wrap {
  width: 100%;
  position: relative;
}
.bg_img {
  /* 宽度 100% 自适应视口，高度按原图比例自动缩放 —— 完整显示不切割 */
  width: 100%;
  height: auto;
  display: block;
}
.text_layer {
  /* position: absolute; */
  /* 按图片实际排版微调纵向位置，后续可根据效果继续调 */
  bottom: 10%;
  left: 50%;
  /* transform: translateX(-50%); */
  text-align: center;
  color: #1a1a1a;
  pointer-events: none;
}
.text_main {
  font-size: 24px;
  font-weight: 700;
  color: #2c6ba5;
  margin-bottom: 12px;
}
.text_tags {
  font-size: 13px;
  color: #555;
  margin-bottom: 18px;
}
.text_tags span {
  display: inline-block;
  padding: 2px 8px;
  margin: 0 4px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 4px;
}
.start_btn {
  pointer-events: auto;
  background: linear-gradient(135deg, #2c6ba5, #3d8fd1);
  color: #fff;
  border: none;
  border-radius: 25px;
  padding: 10px 40px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 14px;
  box-shadow: 0 4px 12px rgba(44, 107, 165, 0.35);
}
.text_tip {
  font-size: 11px;
  color: #999;
  line-height: 1.5;
}
</style>